import { Component } from '@angular/core';

@Component({
  selector: 'upsc-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.scss']
})
export class LoginLayoutComponent {

}
